import { useState, useContext } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import logo from "../../assets/white_trans_logo.png";
import { Menu, X, User } from "lucide-react";
import navLink from "./NavLinks";
import classNames from "classnames";
import dashboardLogo from "../../assets/white_trans_logo.png";
import { AuthContext } from "../AuthContext";
import { UserContext } from "../UserContext";

interface MobileHeaderProps {
  isDashboard?: boolean;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({ isDashboard = false }) => {
  const { setSession } = useContext(AuthContext);
  const [isOpen, setIsOpen] = useState(false);
  const user = useContext(UserContext).user;
  const isAdmin = user?.role === "ADMIN";

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  const navigate = useNavigate();
  const handleLogout = () => {
    setIsOpen(false);
    setSession(null);
    navigate("/");
  };

  return (
    <header
      className={classNames(
        "z-50 w-full sticky top-0 items-center justify-between bg-header-secondary",
        {
          "bg-header-secondary": !isDashboard,
          "bg-white": isDashboard,
        }
      )}
    >
      <div
        className={classNames(
          "flex  justify-between pl-5 py-7 items-center text-white ",
          {
            "shadow-white-sm": !isOpen,
          }
        )}
      >
        <Link to="/" onClick={() => isOpen && toggleNavbar()}>
          <img
            src={isDashboard ? dashboardLogo : logo}
            alt="Logo"
            className={classNames("h-12 w-33 overflow-hidden", {
              "invert opacity-70 group-hover:opacity-100": isDashboard,
            })}
          />
        </Link>
        <button
          className="pr-7"
          onClick={() => {
            toggleNavbar();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          {isOpen ? (
            <X size="35" color={isDashboard ? "#565656" : "white"} />
          ) : isDashboard ? (
            <User size="35" color="#565656" />
          ) : (
            <Menu size="35" color="white" />
          )}
        </button>
      </div>
      {isOpen && (
        <div className="bg-inherit text-white border-b border-gray-300">
          {navLink(true, isDashboard, isAdmin).map((e: any, index: any) => (
            <div
              className="mr-20 ml-20 last:border-0 border-b flex justify-center py-3 last:pt-3 last:pb-5"
              key={index}
            >
              <NavLink
                className={classNames(
                  "items-center justify-center hover:bg-white/10",
                  {
                    "text-invert": isDashboard,
                    "text-white": !isDashboard,
                  }
                )}
                to={e.link}
                onClick={() => {
                  toggleNavbar();
                }}
              >
                {e.titel}
              </NavLink>
            </div>
          ))}
          {isDashboard && (
            <div className="mr-20 ml-20 last:border-0 border-b flex justify-center py-3 last:pt-3 last:pb-5">
              <button
                onClick={handleLogout}
                className="items-center flex justify-center w-full text-left hover:bg-white/10 text-red-400"
              >
                Logout
              </button>
            </div>
          )}
        </div>
      )}
    </header>
  );
};

export default MobileHeader;
